import { render, staticRenderFns } from "./message-reference.vue?vue&type=template&id=5bd5101a&scoped=true"
import script from "./message-reference.vue?vue&type=script&lang=js"
export * from "./message-reference.vue?vue&type=script&lang=js"
import style0 from "./message-reference.vue?vue&type=style&index=0&id=5bd5101a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd5101a",
  null
  
)

export default component.exports